(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.ko = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: '데이터 없음'
      },
      combobox: {
        placeholder: '선택',
        searchPlaceholder: '검색'
      },
      datepicker: {
        apply: '적용',
        clearSelection: '지우기',
        pickADays: '요일 선택',
        prevYear: '이전 해',
        nextYear: '다음 해',
        prevMonth: '이전 달',
        nextMonth: '다음 달',
        year: '',
        month1: '1월',
        month2: '2월',
        month3: '3월',
        month4: '4월',
        month5: '5월',
        month6: '6월',
        month7: '7월',
        month8: '8월',
        month9: '9월',
        month10: '10월',
        month11: '11월',
        month12: '12월',
        weeks: {
          sun: '일',
          mon: '월',
          tue: '화',
          wed: '수',
          thu: '목',
          fri: '금',
          sat: '토'
        },
        months: {
          jan: '1월',
          feb: '2월',
          mar: '3월',
          apr: '4월',
          may: '5월',
          jun: '6월',
          jul: '7월',
          aug: '8월',
          sep: '9월',
          oct: '10월',
          nov: '11월',
          dec: '12월'
        },
        pickADay: '요일 선택'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: '데이터 없음'
      },
      filepicker: {
        browse: '찾아보기',
        select: '파일 선택'
      },
      filter: {
        apply: '적용',
        cancel: '취소',
        filterButton: '필터',
        reset: '재설정 필터',
        resetDefault: '기본값으로 재설정'
      },
      search: {
        noDataMessage: '데이터 없음'
      },
      'multi-search': {
        'separator-and': '및',
        'search-button': '검색',
        'search-placeholder': '이름별 검색'
      },
      select: {
        all: '모두',
        clearSelection: '선택 지우기',
        noMatch: '데이터 없음',
        noData: '데이터 없음',
        placeholder: '선택',
        item: '항목',
        selected: '선택됨',
        found: '검색됨'
      },
      upload: {
        browseButton: '찾아보기',
        text: '업로드할 파일을 끌어서 놓거나 "찾아보기" 클릭',
        tip: '각각 최대 25MB의 파일 10개를 업로드할 수 있음'
      },
      table: {
        emptyText: '데이터 없음'
      },
      tree: {
        emptyText: '데이터 없음'
      }
    }
  };
  _exports.default = _default;
});